// tslint:disable:no-unused-expression

interface StylesType {
  xs?: any;
  sm?: any;
  md?: any;
  lg?: any;
}

export const xs = 0;
export const sm = 768;
export const md = 992;
export const lg = 1200;

export const applyBreakpoints = (width: number, styles: StylesType) => {
  const stylesPush: any[] = [];
  width >= xs && styles.xs && stylesPush.push(styles.xs);
  width >= sm && styles.sm && stylesPush.push(styles.sm);
  width >= md && styles.md && stylesPush.push(styles.md);
  width >= lg && styles.lg && stylesPush.push(styles.lg);

  return stylesPush;
}



// WEBPACK FOOTER //
// ./src/utils/breakpoints.ts